interface TransferenciaData {
  idAutonomoDe: string;
  idAutonomoPara: string;
  empreendimentos: { label: string; value: string }[];
  idsRevendaUnidade: string[];
}

export const defaultTransferenciaData: TransferenciaData = {
  idAutonomoDe: "",
  idAutonomoPara: "",
  empreendimentos: [],
  idsRevendaUnidade: [],
};
